/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamPlayerStatus } from './PamPlayerStatus';
import {
    PamPlayerStatusFromJSON,
    PamPlayerStatusFromJSONTyped,
    PamPlayerStatusToJSON,
} from './PamPlayerStatus';

/**
 * The result of a PAM account-status transition: what the status now is, and when it
 * changed. Carries only what changed rather than a whole refreshed player.
 * @export
 * @interface PamAccountStatusResponse
 */
export interface PamAccountStatusResponse {
    /**
     * ISO-8601 timestamp of the status transition.
     * @type {Date}
     * @memberof PamAccountStatusResponse
     */
    statusChangedAt: Date;
    /**
     * 
     * @type {PamPlayerStatus}
     * @memberof PamAccountStatusResponse
     */
    status: PamPlayerStatus;
}



/**
 * Check if a given object implements the PamAccountStatusResponse interface.
 */
export function instanceOfPamAccountStatusResponse(value: object): value is PamAccountStatusResponse {
    if (!('statusChangedAt' in value) || value['statusChangedAt'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PamAccountStatusResponseFromJSON(json: any): PamAccountStatusResponse {
    return PamAccountStatusResponseFromJSONTyped(json, false);
}

export function PamAccountStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamAccountStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'statusChangedAt': (new Date(json['statusChangedAt'])),
        'status': PamPlayerStatusFromJSON(json['status']),
    };
}

export function PamAccountStatusResponseToJSON(value?: PamAccountStatusResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'statusChangedAt': ((value['statusChangedAt']).toISOString()),
        'status': PamPlayerStatusToJSON(value['status']),
    };
}

